<template>
    <v-card-text class="subtitle-1 mt-3" v-if="order.type === 'p2p'">
        <p v-if="!isPoster">
            This is a currency swap between you and someone in {{ posterCountry.name }}.
            The person wants your {{ order.matcher_currency }} {{ formatAmount(order.matcher_amount) }} and in
            exchange he/she gives you his/her {{ order.poster_currency }} {{ formatAmount(order.poster_amount) }}.
            A lien/fund-hold has been placed by
            <img :src="bankLogo" height="15" v-if="bankLogo" />
            <span v-else>a bank</span>
            on this person's bank account for the amount of {{ order.poster_currency }} {{ formatAmount(order.poster_amount) }}.
        </p>

        <p v-else>
            This is a currency swap between you and someone in {{ posterCountry.name }}.
            The person wants your benefactor's {{ order.matcher_currency }} {{ formatAmount(order.matcher_amount) }}
            and in exchange he/she gives you {{ order.poster_currency }} {{ formatAmount(order.poster_amount) }}.
            A lien/fund-hold has been placed by
            <img :src="bankLogo" height="15" v-if="bankLogo" />
            <span v-else>a bank</span>
            on this person's bank account for the amount of {{ order.poster_currency }} {{ formatAmount(order.poster_amount) }}.
        </p>

        <p v-if="!isPoster" class="mb-0">
            Upon Kaoshi confirming your payment of {{ order.matcher_currency }} {{ formatAmount(order.matcher_amount) }} for
            this swap, the {{ order.poster_currency }} {{ formatAmount(order.poster_amount) }} will be transferred
            from this person's bank account at
            <img :src="bankLogo" height="15" v-if="bankLogo" />
            <span v-else>a bank</span>
            to your recipient's bank account in {{ posterCountry.name }}.
        </p>
        <p v-else class="mb-0">
            Upon Kaoshi confirming your benefactor's payment of {{ order.matcher_currency }} {{ formatAmount(order.matcher_amount) }}
            to this person for this swap, the {{ order.poster_currency }} {{ formatAmount(order.poster_amount) }}
            will be transfered from this person's bank account at
            <img :src="bankLogo" height="15" v-if="bankLogo" />
            <span v-else>a bank</span>
            to your bank account in {{ posterCountry.name }}
        </p>
    </v-card-text>

    <v-card-text v-else-if="order.type === 'hybrid' && order.isNgHybrid" class="subtitle-1 mt-3">
        <p>
            This is a currency swap between you and someone in {{ posterCountry.name }}.
            The person wants your {{ order.matcher_currency }} {{ formatAmount(order.matcher_amount) }}
            ({{ order.pb_currency }} {{ formatAmount(order.pb_amount) }}) and in exchange he/she gives
            you his/her {{ order.poster_currency }} {{ formatAmount(order.poster_amount) }}.
            A lien/fund-hold has been placed by <img :src="bankLogo" height="15" /> on this
            person's bank account for the amount of {{ order.poster_currency }} {{ formatAmount(order.poster_amount) }}.
        </p>
        <p>
            Upon Kaoshi confirming your payment of {{ order.matcher_currency }} {{ formatAmount(order.matcher_amount) }}
            ({{ order.pb_currency }} {{ formatAmount(order.pb_amount) }}) for this swap, the
            {{ order.poster_currency }} {{ formatAmount(order.poster_amount) }} will be transferred from this person's
            bank account at <img :src="bankLogo" height="15" /> to your recipient's bank account in {{ posterCountry.name }}.
        </p>
        <p class="mb-0">
            You will send this person in {{ posterCountry.name }} the {{ order.matcher_currency }} {{ formatAmount(order.matcher_amount) }}
            ({{ order.pb_currency }} {{ formatAmount(order.pb_amount) }})
        </p>
    </v-card-text>

    <v-card-text v-else-if="order.type === 'hybrid' && !order.isNgHybrid" class="subtitle-1 mt-3">
        <p>
            This is a currency swap between you and someone in {{ posterCountry.name }}.
            The person wants your {{ order.matcher_currency }} {{ formatAmount(order.matcher_amount) }}
            ({{ order.pb_currency }} {{ formatAmount(order.pb_amount) }}) and in exchange he/she gives
            you his/her {{ order.poster_currency }} {{ formatAmount(order.poster_amount) }}.
            A lien/fund-hold has been placed by <img :src="bankLogo" height="15" /> on this
            person's bank account for the amount of {{ order.poster_currency }} {{ formatAmount(order.poster_amount) }}.
        </p>
        <p>
            Upon Kaoshi confirming your payment of {{ order.matcher_currency }} {{ formatAmount(order.matcher_amount) }}
            ({{ order.pb_currency }} {{ formatAmount(order.pb_amount) }}) for this swap, the
            {{ order.poster_currency }} {{ formatAmount(order.poster_amount) }} will be transferred from this person's
            bank account at <img :src="bankLogo" height="15" /> to your recipient's bank account in {{ posterCountry.name }}.
        </p>
        <p class="mb-0">
            You will send this person in {{ posterCountry.name }} the {{ order.matcher_currency }} {{ formatAmount(order.matcher_amount) }}
            ({{ order.pb_currency }} {{ formatAmount(order.pb_amount) }}) using {{ order.company.name }}
            <img :src="order.company.logo" height="15" v-if="order.company && order.company.logo" />
        </p>
    </v-card-text>

    <v-card-text v-else-if="order.type === '3po'" class="subtitle-1 mt-3">
        <p>
            This is an international money transfer service from {{ order.company.name }}.
            You will be re-directed to their site to complete this transaction.
        </p>

        <p class="mb-0">
            Kaoshi's Sticky Note extension will transfer your information and your
            recipient's information to {{ order.company.name }}'s website
            making it easier and faster to register and complete this transaction.
        </p>
    </v-card-text>
</template>

<script>
import countries from '../../../modules/countries.json';

export default {
    props: {
        order: Object,
    },
    computed: {
        posterCountry() {
            return countries.find((country) => country.iso2 === this.order.poster_country);
        },
        isPoster() {
            return this.$store.state.user.can_post_offers;
        },
        bankLogo() {
            const {
                poster_country: country,
                posterPaymentMethod,
            } = this.order;

            if (!posterPaymentMethod) {
                return null;
            }

            const bankCode = posterPaymentMethod.bank_code;

            if (!bankCode) {
                return null;
            }

            return `/images/banks/${country.toLowerCase()}/${bankCode}.png`;
        },
    },
};
</script>
